import React from "react";
import "./waiting-screen.scss";
import Spacer from "../../ui/Spacer";
import Card from "../../ui/Card";
import background from "../../assets/images/background.avif";
import Typo from "../../ui/Typo";
import Logo from "../../components/Logo";
import { Divider } from "primereact/divider";
// import EmailCollector from "../../components/EmailCollector";
import WhatsAppButton from "../../components/WhatsAppButton";

const WaitingScreen = () => {
  return (
    <div
      className="waiting-screen"
      style={{
        backgroundImage: `url(${background})`,
      }}
    >
      <Card>
        <div className="waiting-screen-container">
          <Spacer size={4} />
          <Logo animate size="small" />
          <Spacer size={4} />
          <Typo variant="title">Quelque chose de DELICIOUS se prépare.</Typo>
          <Spacer size={2} />
          <Typo variant="paragraph">Pour en savoir plus, contacte-nous</Typo>
          <Spacer size={2} />
          <WhatsAppButton />
          <Spacer size={7} />

          {/* <EmailCollector />
          <Spacer size={5} /> */}

          <Divider />
          <Spacer size={5} />
          <Logo hasLabel={true} hasPicto={false} />
          <Spacer size={2} />
        </div>
      </Card>
    </div>
  );
};

export default WaitingScreen;
